module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-photo-book-115f869a67d5ff43cfadef4be2a5ebea.jpg";